<template>
  <div>
    <div>
      <EventSlideshow />
    </div>
    <div class="EventList">
      <EventList />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import EventSlideshow from '../../components/EventList/EventSlideshow.vue';
import EventList from '../../components/EventList/EventList.vue';
import './Events.css';

export default {
  name: 'AllEvents',
  components: {
    EventList,
    EventSlideshow,
  },
  methods: {
    ...mapActions({
      fetchInvitationRequests: 'user/fetchInvitationRequests',
    }),
  },
  async mounted() {
    await this.fetchInvitationRequests();
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat");

.EventList {
  margin-top: 13px;
  margin-bottom: 50px;
}
</style>
